<template>
    <div @click="collect()"  class="vCenter collectbtndiv">
      <img :src="favorites==0?'/img/icon/collect.png':'/img/icon/collected.png'" alt="">
      <div class="btntext" v-if="favorites==0">
        收藏
      </div>
      <div class="btntext" v-else>
        取消
      </div>
    </div>
</template>
<script>
export default {
  name: "UmCollect",
  data() {
    return {
      umid: ''
    };
  },
  props: ["sid","appid","favorites","title","favoritessid"],
  mounted() {
    var that = this;
    that.umid=$UMCore.uncompile("umid")
    // var waitReady = function() {
    //   if (that.appid != '' && that.appid != undefined) {
    //     that.collect(); 
    //   } else {
    //     setTimeout(function() {
    //       waitReady();
    //     }, 20);
    //   }
    // };
    // setTimeout(function() {
    //   waitReady();
    // }, 50);
    
  },
  methods: {
    collect() {
        var that = this
        if ($UMCore.uncompile('token')==null) {
            // localStorage.setItem("newsoperate", 1)
            this.$emit('unlogin','');
            return false;
        }
        console.log(JSON.stringify({
                functionname: 'favorites_set',
                appid: that.appid,
                dappuuid: that.sid,
                title: that.title,
                type: that.favorites == 0 ? 0 : 2,
                umid: that.umid,
                sid: that.favoritessid
            }))
        $UMCore.post("/route.lua", {
            data:JSON.stringify({
                functionname: 'favorites_set',
                appid: that.appid,
                dappuuid: that.sid,
                title: that.title,
                type: that.favorites == 0 ? 0 : 2,
                umid: that.umid,
                sid: that.favoritessid
            })
        })
        .then(function(response) {
            if (response.data.status === true) {
                that.favoritessid = response.data.sid
                if(that.favorites == 0) {
                    that.favorites = 1
                } else {
                    that.favorites = 0
                }
                
            } else {
                that.$message.error('网络错误！')
                return false
            }
        })
        .catch(function(error) {})
    },
    
  }
};
</script>
<style lang="scss" scoped>
.collectbtndiv {
  cursor: pointer;
  margin-left: 16px;
  img {
    width: 16px;
    height: 16px;
  }
  .btntext {
    margin-left: 4px;
    font-size: 12px;
    color: #999;
  }
}
</style>




// WEBPACK FOOTER //
// src/packages/collect/um-collect.vue